import search from '../../../../images/search.png'
import { Shop } from '../../../../types'

interface ShopSearchFieldProps {
  searchQuery: string
  searchResults: Shop[]
  isSearching: boolean
  isShopInputFocused: boolean
  onSearchChange: (value: string) => void
  onInputFocus: () => void
  onInputBlur: () => void
  onShopSelect: (shop: Shop) => void
  labelWidth?: number
}

const getStyles = (labelWidth: number): Record<string, React.CSSProperties> => ({
  formGroup: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: '16px',
    marginBottom: '4px',
    pointerEvents: 'none',
    width: `${labelWidth}px`,
    flexShrink: 0,
    marginRight: '8px',
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px',
  },
  inputContainer: {
    flex: 1,
    position: 'relative',
  },
  searchContainer: {
    position: 'relative',
  },
  input: {
    width: '100%',
    padding: '10px 10px 10px 40px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '4px',
  },
  searchIcon: {
    position: 'absolute',
    left: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '16px',
    height: '16px',
    pointerEvents: 'none',
  },
  searchingIndicator: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    fontSize: '14px',
    color: '#666',
  },
  searchResults: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderTop: 'none',
    borderRadius: '0 0 4px 4px',
    zIndex: 10,
    maxHeight: '200px',
    overflowY: 'auto',
  },
  searchResultItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee',
  },
})

const ShopSearchField: React.FC<ShopSearchFieldProps> = ({
  searchQuery,
  searchResults,
  isSearching,
  isShopInputFocused,
  onSearchChange,
  onInputFocus,
  onInputBlur,
  onShopSelect,
  labelWidth = 80,
}) => {
  const styles = getStyles(labelWidth)

  return (
    <div style={styles.formGroup}>
      <label style={styles.label}>
        お店<span style={styles.required}>*</span>
      </label>
      <div style={styles.inputContainer}>
        <div style={styles.searchContainer}>
          <img src={search} alt="search" style={styles.searchIcon} />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={onInputFocus}
            onBlur={onInputBlur}
            placeholder="店名、チェーン名、地域名を入力"
            style={styles.input}
            required
          />
          {isSearching && <div style={styles.searchingIndicator}>検索中...</div>}
        </div>

        {isShopInputFocused && searchResults.length > 0 && (
          <div style={styles.searchResults}>
            {searchResults.map((shop) => (
              <div key={shop.id} style={styles.searchResultItem} onClick={() => onShopSelect(shop)}>
                {shop.chain_name} {shop.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default ShopSearchField
